import React, { useEffect, useState } from 'react';
import { getSidebarConfig } from '../../api/dashboardApi';
import CompanyDashboardShell from './CompanyDashboardShell';

const MotherDashboard = () => {
  const [companyId, setCompanyId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const config = await getSidebarConfig();
        if (config.mother_company?.id) {
          setCompanyId(config.mother_company.id);
        }
      } catch (err) {
        const status = err.response?.status;
        // 403/404 mean "not assigned" (falls through to that message); anything else is a load failure.
        if (status !== 403 && status !== 404) {
          setError(
            err.response?.data?.message ||
              "Could not load the dashboard. Please try again later."
          );
        }
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) {
    return <div className="cd-loading">Loading dashboard...</div>;
  }

  if (error) {
    return <div className="cd-error">{error}</div>;
  }

  if (!companyId) {
    return <div className="cd-error">You are not assigned to the mother company.</div>;
  }

  return <CompanyDashboardShell companyId={companyId} />;
};

export default MotherDashboard;
